<div
  class="card pipes-req-shell"
  [class.pipes-station-only]="onlyStation"
>
  <div class="card-body pipes-card-body">
    <!-- En la solicitud de pipas (dos tablas apiladas + botón) el wrapper crece con el contenido
             (sin height-panel fijo) para que la tarjeta las contenga; cada tabla tiene su scroll interno. -->
    <div class="dataTables_wrapper" [class.height-panel]="!requestFlow">
      <!-- ==================== Solicitud de Pipas — rediseño (requestFlow) ==================== -->
      <!-- "Nueva solicitud" (solo estación): formulario inline MULTI-pipa, sin card contenedora.
                 Reutiliza el mismo modelo/lógica que el modal multi-pipa (orderForms, addOrderRow,
                 removeOrderRow, updateRowSpace, rowOverSpace, orderFormValid, submitOrderForm). En
                 Tablero (grupo de estaciones) la estación se elige dentro del modal, así que en su
                 lugar se muestra el CTA que lo abre (bloque aparte, sin cambios). -->
      <div
        class="pipes-req__section pipes-req__section--new"
        *ngIf="reqst === 1 && requestFlow && onlyStation && !cronoOnly"
      >
        <h2 class="pipes-req__section-title">Nueva solicitud</h2>

        <!-- Header de labels compartido: mismas columnas que cada fila de pipa de abajo (sin caja). -->
        <div class="pipes-req__cols-head">
          <span>PO#</span>
          <span>Fecha requerida</span>
          <span>Capacidad</span>
          <span>Tipo</span>
          <span>Material</span>
          <span aria-hidden="true"></span>
        </div>

        <div
          class="pipes-req__pipa"
          *ngFor="let f of orderForms; let i = index"
        >
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">PO#</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="f.po"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. PET8EX01"
            />
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Fecha requerida</span>
            <input
              type="date"
              class="form-control"
              [class.is-placeholder]="!f.loadDate"
              [class.is-invalid]="rowDateTooEarly(f)"
              [min]="minRequestDate"
              [title]="rowDateTooEarly(f) ? 'La fecha requerida no puede ser anterior a hoy' : ''"
              [(ngModel)]="f.loadDate"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            />
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Capacidad</span>
            <!-- Texto con separador de miles (el modelo sigue numérico vía parseThousands). -->
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              (keypress)="numberOnly($event)"
              [class.over-space]="rowOverSpace(f)"
              [ngModel]="formatThousands(f.capacity)"
              (ngModelChange)="f.capacity = parseThousands($event)"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. 30,000"
            />
            <!-- Candado de inventario: mismo mecanismo/copys que el modal multi-pipa. -->
            <small class="space-hint muted" *ngIf="f.spaceLoading">
              <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
              Consultando espacio…
            </small>
            <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin ampliar
                 más"): click abre el modal "¿Por qué no hay espacio?". -->
            <small
              class="space-hint"
              [class.over]="rowOverSpace(f)"
              *ngIf="!f.spaceLoading && f.availableSpace != null"
              (click)="rowOverSpace(f) && openSpaceInfo(f)"
              [title]="
                rowOverSpace(f)
                  ? 'Ver por qué no hay espacio'
                  : f.spaceBasis === 'theoretical'
                    ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                    : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
              "
            >
              <i
                class="fa"
                [ngClass]="
                  rowOverSpace(f) ? 'fa-exclamation-triangle' : 'fa-tint'
                "
                aria-hidden="true"
              ></i>
              <span>
                <ng-container *ngIf="!rowOverSpace(f)"
                  >Espacio disp.
                  {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                >
                <ng-container *ngIf="rowOverSpace(f) && rowEffectiveSpace(f)"
                  >Excede máx.
                  {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                >
                <ng-container *ngIf="rowOverSpace(f) && !rowEffectiveSpace(f)"
                  >Sin espacio disponible</ng-container
                >
                <i
                  class="fa fa-question-circle space-hint__q"
                  *ngIf="rowOverSpace(f)"
                  aria-hidden="true"
                ></i>
              </span>
            </small>
            <small
              class="space-hint muted"
              *ngIf="
                !f.spaceLoading && f.spaceChecked && f.availableSpace == null
              "
              title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
            >
              <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos de
              inventario
            </small>
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Tipo</span>
            <select
              class="form-control"
              [class.is-placeholder]="!f.product"
              [(ngModel)]="f.product"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            >
              <option value="" disabled selected>Selecciona…</option>
              <option *ngFor="let p of orderProductOptions" [value]="p.value">
                {{ p.label }}
              </option>
            </select>
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Material</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="f.material"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. MOBIL R87 OCT GASOLINE MEXICO ROC"
            />
          </div>
          <div class="pipes-req__pipa__remove">
            <!-- Patrón estándar de eliminar del portal (.icon.delete, mismo del cronograma).
                             Siempre visible: deshabilitado mientras solo haya una pipa. -->
            <i
              class="fa fa-trash-o icon delete"
              aria-hidden="true"
              [class.disabled]="orderForms.length < 2"
              (click)="orderForms.length > 1 && removeOrderRow(i)"
              [title]="
                orderForms.length > 1
                  ? 'Eliminar pipa'
                  : 'La solicitud necesita al menos una pipa'
              "
            ></i>
          </div>
        </div>

        <button
          type="button"
          class="pipes-req__add-pipa"
          (click)="addOrderRow()"
        >
          <i class="fa fa-plus" aria-hidden="true"></i> Agregar pipa
        </button>

        <div class="pipes-req__new-foot">
          <button
            type="button"
            class="pipes-req__submit"
            [disabled]="!orderFormValid || savingOrder"
            (click)="submitOrderForm()"
          >
            {{ savingOrder ? "Enviando…" : "Enviar pedido" }}
          </button>
        </div>
      </div>

      <!-- Tablero (grupo de estaciones): mismo formulario inline multi-pipa que la guía
                 (onlyStation), con una columna extra "Estación" (entre Fecha requerida y
                 Capacidad, mismo orden MOBICO que el modal) porque acá la estación no es
                 implícita. Reutiliza el mismo modelo/lógica (orderForms, addOrderRow,
                 removeOrderRow, updateRowSpace, rowOverSpace, orderFormValid,
                 submitOrderForm); el ngx-select de Estación es el mismo componente buscable
                 que usa el modal (f.station, updateRowSpace en el change). -->
      <div
        class="pipes-req__section pipes-req__section--new pipes-req__section--with-station"
        *ngIf="reqst === 1 && requestFlow && !onlyStation"
      >
        <h2 class="pipes-req__section-title">Nueva solicitud</h2>

        <!-- Header de labels compartido: mismas columnas que cada fila de pipa de abajo (sin caja). -->
        <div class="pipes-req__cols-head">
          <span>PO#</span>
          <span>Fecha requerida</span>
          <span>Estación</span>
          <span>Capacidad</span>
          <span>Tipo</span>
          <span>Material</span>
          <span aria-hidden="true"></span>
        </div>

        <div
          class="pipes-req__pipa"
          *ngFor="let f of orderForms; let i = index"
        >
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">PO#</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="f.po"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. PET8EX01"
            />
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Fecha requerida</span>
            <input
              type="date"
              class="form-control"
              [class.is-placeholder]="!f.loadDate"
              [class.is-invalid]="rowDateTooEarly(f)"
              [min]="minRequestDate"
              [title]="rowDateTooEarly(f) ? 'La fecha requerida no puede ser anterior a hoy' : ''"
              [(ngModel)]="f.loadDate"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            />
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Estación</span>
            <!-- appendTo body: el desplegable se renderiza fuera del cuerpo con scroll
                             para que el scroll de la página no lo recorte. -->
            <ngx-select
              class="op-ngx-select"
              [allowClear]="false"
              [items]="stations"
              optionValueField="value"
              optionTextField="label"
              placeholder="Selecciona…"
              appendTo="body"
              [dropDownMenuOtherClasses]="'op-appended-dropdown'"
              [(ngModel)]="f.station"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            >
              <ng-template ngx-select-option-not-found let-input>
                "{{ input }}" no encontrada
              </ng-template>
            </ngx-select>
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Capacidad</span>
            <!-- Texto con separador de miles (el modelo sigue numérico vía parseThousands). -->
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              (keypress)="numberOnly($event)"
              [class.over-space]="rowOverSpace(f)"
              [ngModel]="formatThousands(f.capacity)"
              (ngModelChange)="f.capacity = parseThousands($event)"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. 30,000"
            />
            <!-- Candado de inventario: mismo mecanismo/copys que el modal multi-pipa. -->
            <small class="space-hint muted" *ngIf="f.spaceLoading">
              <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
              Consultando espacio…
            </small>
            <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin ampliar
                 más"): click abre el modal "¿Por qué no hay espacio?". -->
            <small
              class="space-hint"
              [class.over]="rowOverSpace(f)"
              *ngIf="!f.spaceLoading && f.availableSpace != null"
              (click)="rowOverSpace(f) && openSpaceInfo(f)"
              [title]="
                rowOverSpace(f)
                  ? 'Ver por qué no hay espacio'
                  : f.spaceBasis === 'theoretical'
                    ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                    : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
              "
            >
              <i
                class="fa"
                [ngClass]="
                  rowOverSpace(f) ? 'fa-exclamation-triangle' : 'fa-tint'
                "
                aria-hidden="true"
              ></i>
              <span>
                <ng-container *ngIf="!rowOverSpace(f)"
                  >Espacio disp.
                  {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                >
                <ng-container *ngIf="rowOverSpace(f) && rowEffectiveSpace(f)"
                  >Excede máx.
                  {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                >
                <ng-container *ngIf="rowOverSpace(f) && !rowEffectiveSpace(f)"
                  >Sin espacio disponible</ng-container
                >
                <i
                  class="fa fa-question-circle space-hint__q"
                  *ngIf="rowOverSpace(f)"
                  aria-hidden="true"
                ></i>
              </span>
            </small>
            <small
              class="space-hint muted"
              *ngIf="
                !f.spaceLoading && f.spaceChecked && f.availableSpace == null
              "
              title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
            >
              <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos de
              inventario
            </small>
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Tipo</span>
            <select
              class="form-control"
              [class.is-placeholder]="!f.product"
              [(ngModel)]="f.product"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="updateRowSpace(f)"
            >
              <option value="" disabled selected>Selecciona…</option>
              <option *ngFor="let p of orderProductOptions" [value]="p.value">
                {{ p.label }}
              </option>
            </select>
          </div>
          <div class="pipes-req__pipa__field">
            <span class="pipes-req__pipa__mlabel">Material</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="f.material"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. MOBIL R87 OCT GASOLINE MEXICO ROC"
            />
          </div>
          <div class="pipes-req__pipa__remove">
            <!-- Patrón estándar de eliminar del portal (.icon.delete, mismo del cronograma).
                             Siempre visible: deshabilitado mientras solo haya una pipa. -->
            <i
              class="fa fa-trash-o icon delete"
              aria-hidden="true"
              [class.disabled]="orderForms.length < 2"
              (click)="orderForms.length > 1 && removeOrderRow(i)"
              [title]="
                orderForms.length > 1
                  ? 'Eliminar pipa'
                  : 'La solicitud necesita al menos una pipa'
              "
            ></i>
          </div>
        </div>

        <button
          type="button"
          class="pipes-req__add-pipa"
          (click)="addOrderRow()"
        >
          <i class="fa fa-plus" aria-hidden="true"></i> Agregar pipa
        </button>

        <div class="pipes-req__new-foot">
          <button
            type="button"
            class="pipes-req__submit"
            [disabled]="!orderFormValid || savingOrder"
            (click)="submitOrderForm()"
          >
            {{ savingOrder ? "Enviando…" : "Enviar pedido" }}
          </button>
        </div>
      </div>

      <!-- Sección "Solicitudes": patrón section-header (kicker + hairline + filtros SIN label,
                 solo placeholder/opción descriptiva — task 2026-07-10 "eliminar los títulos")
                 seguido de la tabla única "Solicitudes" (formato MOBICO): UNA fila por pedido,
                 sin desglose de historial. El Tipo y el estatus reflejan la solicitud en curso: el
                 cambio en vuelo si lo hay (con su valor nuevo), si no el pedido tal cual. -->
      <div
        class="pipes-req__orders pipes-req__section"
        *ngIf="requestFlow && !cronoOnly"
      >
        <!-- Título + filtros en la MISMA banda (una sola línea del header, sin
                     banda vertical extra para los filtros): título a la izquierda,
                     filtros a la derecha. La hairline de cierre del header la aporta
                     .pipes-req__orders-head (no el título, ver SCSS). -->
        <div class="pipes-req__orders-head">
          <h2 class="pipes-req__section-title">Solicitudes</h2>
          <div class="pipes-req__orders-filters">
            <!-- Grupo/Zona/Estación (Tablero: elegir de qué grupo/comercializadora se ven las
                         solicitudes). SOLO !onlyStation: en la guía (onlyStation) la estación ya es
                         implícita y estos tres filtros no aplican, por eso el guard extra en cada uno
                         (el header "Solicitudes" completo se comparte con la guía vía *ngIf="requestFlow"). -->
            <div class="pipes-req__field" *ngIf="!onlyStation && rol === 'Dios'">
              <app-select-group></app-select-group>
            </div>
            <!-- Zona se ELIMINÓ de esta banda (task 2026-07-09, mismo criterio que
                 en el header del tablero de cronograma): con el filtro de Estación
                 y la columna Estación en la tabla, la zona solo estorbaba. -->
            <div class="pipes-req__field" *ngIf="!onlyStation">
              <!-- Dropdown buscable de estaciones (Ajuste A: sin "X" de limpiar — allowClear=false
                           — porque el usuario no la quiere; en su lugar stationFilterOptions incluye
                           "Todas las estaciones" (value '') como primera opción para volver a "sin
                           filtro"). Matchea por station_id, ver matchesFilters en el .ts. -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="stationFilterOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todas las estaciones"
                [(ngModel)]="stationFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
                <ng-template ngx-select-option-not-found let-input
                  >"{{ input }}" no encontrada</ng-template
                >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <!-- currentWeekLabel: sin título arriba, la opción de la semana
                   actual se muestra como "Semana actual" para que el control se
                   autoexplique (las demás semanas conservan su rango de fechas). -->
              <app-select-week currentWeekLabel="Semana actual"></app-select-week>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterProducts"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los productos"
                [(ngModel)]="productFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterStatuses"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los estatus"
                [(ngModel)]="statusFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
          </div>
        </div>

        <!-- Scroll por wrapper CSS (no el virtual de ngx-datatable): con columnMode force + scroll
                 vertical y muchas filas (Tablero) el header/cuerpo se desalinean. Con scrollbarV=false
                 la tabla renderiza todas las filas y el wrapper (header sticky) hace el scroll. -->
        <!-- Sin paginación (pedido 2026-07-13): todas las solicitudes bajo el
             scroll interno, pintadas por lotes (ver onOrdersScroll). -->
        <div class="orders-summary-scroll" *ngIf="reqst === 1" (scroll)="onOrdersScroll($event)">
          <!-- trackByProp: SIN él ngx-datatable trackea por índice posicional y al
                     insertar/quitar filas de historial las clases se recorren entre
                     elementos DOM reusados → re-animaba filas que no cambiaron.
                     (rowIdentity NO alimenta el trackBy; es bookkeeping interno.) -->
          <ngx-datatable
            class="bootstrap selection-cell orders-summary"
            [columnMode]="'force'"
            [headerHeight]="50"
            [rowHeight]="32"
            [rows]="requestRows"
            [scrollbarV]="false"
            [scrollbarH]="false"
            [rowClass]="getRowClass"
            [rowIdentity]="rowIdentity"
            [trackByProp]="'_id'"
            [messages]="{ emptyMessage: emptyRequestsMessage }"
          >
            <!-- Columna genuinamente más angosta (coordinación 2026-07-09: con
                     columnMode force el minWidth es un piso duro — ver forceFillColumnWidths
                     de ngx-datatable — así que agrandarlo para el chip largo la hacía MÁS
                     ancha, lo opuesto a lo pedido). En vez de eso se comprimió el FOOTPRINT
                     del chip (ver .type-chip y .oh-toggle-slot en el SCSS, scopeados a esta
                     tabla): el chip ahora envuelve a 2 líneas dentro de la fila de 44px.
                     minWidth recalculado con el chip compacto (medido con Chrome headless,
                     mismo método que antes): slot del caret 15px + chip "Cambio de capacidad"
                     con max-width 80px + inset de celda 14px+14px ≈123px de contenido real →
                     128 con margen. Render real de la columna queda en ese rango (120-130px),
                     notablemente más angosta que los 165px originales. -->
            <ngx-datatable-column
              prop="type_label"
              name="Tipo"
              [width]="128"
              [minWidth]="128"
              [maxWidth]="150"
              [sortable]="false"
              [cellClass]="'left-side green-gray'"
              [headerClass]="'left-side top-side green-gray'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- Slot fijo del caret: reserva el mismo ancho en todas las filas para
                             que el chip quede alineado. El caret solo aparece en el pedido padre
                             con historial; al expandir, sus filas se insertan debajo. -->
                <!-- Chevron rotatorio (mecánica de acordeón): un solo ícono que gira
                             90° al abrir, en lugar de intercambiar right/down sin transición. -->
                <span class="oh-toggle-slot">
                  <i
                    class="fa fa-chevron-right oh-toggle"
                    [class.open]="isHistoryOpen(row)"
                    *ngIf="!row.is_history && row.has_history"
                    title="Ver historial de la solicitud"
                    aria-hidden="true"
                    (click)="toggleHistory(row)"
                  ></i>
                </span>
                <span class="type-chip" [ngClass]="row.change_kind">{{
                  row.type_label
                }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="po_number"
              name="PO"
              [width]="100"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>{{
                row.po_number || "—"
              }}</ng-template>
            </ngx-datatable-column>
            <!-- Fecha de solicitud = cuándo se creó (timestamp real → hora de México).
                     Encabezado en UNA línea (task 2026-07-09 "ocupan dos renglones"): ancho
                     suficiente para el label completo + nowrap del header (ver SCSS). -->
            <ngx-datatable-column
              prop="request_date"
              name="Fecha de solicitud"
              [width]="125"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row.request_date
                    ? (row.request_date | date: "dd/MM/yy" : "-0600" : "es")
                    : "—"
                }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="order_delivery_date"
              name="Fecha requerida"
              [width]="115"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row.order_delivery_date
                    ? (row.order_delivery_date
                      | date: "dd/MM/yy" : "+0000" : "es")
                    : "—"
                }}
              </ng-template>
            </ngx-datatable-column>
            <!-- Solo en Tablero (varias estaciones): en la vista de una sola estación
                     (onlyStation) la columna sobra, la estación ya es la seleccionada. -->
            <ngx-datatable-column
              *ngIf="!onlyStation"
              prop="station_name"
              name="Estación"
              [width]="160"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>{{
                row.station_name || "—"
              }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              prop="truck_capacity"
              name="Capacidad"
              [width]="100"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row.truck_capacity
                    ? (row.truck_capacity | number: "1.0-0")
                    : "—"
                }}
              </ng-template>
            </ngx-datatable-column>
            <!-- Producto angosto (task 2026-07-09 "ocupa mucho espacio"): el material
                 largo ya se trunca con tooltip (.material-cell). -->
            <ngx-datatable-column
              prop="material"
              name="Producto"
              [width]="150"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="material-cell" [title]="row.material || ''">{{
                  row.material || "—"
                }}</span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Valor nuevo solicitado (solo cuando hay un cambio en curso; '—' si no) -->
            <ngx-datatable-column
              prop="new_value"
              name="Nuevo valor"
              [width]="110"
              [maxWidth]="140"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="new-value">{{ row.new_value }}</span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Respuesta MOBICO = estatus de lo que la fila muestra; el cambio en curso
                     va en color de revisión (naranja) para distinguirlo del pedido normal -->
            <ngx-datatable-column
              prop="status_label"
              name="Respuesta MOBICO"
              [width]="170"
              [sortable]="false"
              [headerClass]="'top-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                  class="status-label"
                  [ngClass]="{
                    'status-confirmed': row.status === 'confirmed',
                    'status-rejected': row.status === 'rejected',
                    'status-review':
                      row.status === 'review' || row.in_flight_change,
                  }"
                >
                  {{ row.status_label || "—" }}
                </span>
              </ng-template>
            </ngx-datatable-column>
            <!-- Acciones del pedido: realizar cambio / cancelar (vía aprobación de MOBICO).
                     Botones etiquetados (feedback: los íconos pasaban desapercibidos) con la
                     pareja de botones del portal: "Cambiar" verde CTA y "Cancelar" gris, como
                     los confirm-btn de los modales de este flujo. minWidth evita que
                     columnMode force comprima la columna y corte los botones.
                     SIEMPRE visibles (task 2026-07-10, antes la celda mostraba '—'):
                     deshabilitados cuando el pedido ya no admite acciones (canCancelOrder) —
                     mismo patrón enable/disable que el trash de eliminar pipa del formulario;
                     el tooltip explica el motivo (orderActionsDisabledReason). Solo las filas
                     de historial siguen sin botones. -->
            <ngx-datatable-column
              name="Acciones"
              [width]="160"
              [minWidth]="150"
              [maxWidth]="185"
              [sortable]="false"
              [cellClass]="'right-side'"
              [headerClass]="'top-side right-side'"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- Orden gris → verde (task 2026-07-13 "orden de acciones"):
                     el par replica a los modales del flujo, secundaria primero
                     y la acción principal (verde) al final. -->
                <ng-container *ngIf="!row.is_history; else noOrderActions">
                  <button
                    type="button"
                    class="row-action-btn gray"
                    [disabled]="!canCancelOrder(row)"
                    [title]="
                      orderActionsDisabledReason(row) ||
                      'Solicitar la cancelación del pedido'
                    "
                    (click)="warningDeleteOrder(row)"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="row-action-btn green"
                    [disabled]="!canCancelOrder(row)"
                    [title]="
                      orderActionsDisabledReason(row) ||
                      'Solicitar un cambio del pedido'
                    "
                    (click)="openChangeForm(row)"
                  >
                    Cambiar
                  </button>
                </ng-container>
                <ng-template #noOrderActions
                  ><span class="mobico-response">—</span></ng-template
                >
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>

      </div>

      <!-- Envoltura de la card "Cronograma": comparte la MISMA tabla que la vista !requestFlow
                 (view=pipes), así que no se puede duplicar. Ahora SIEMPRE se ve como card
                 (.pipes-req__section, aplicada sin condición: las 3 vistas que llegan a este div
                 comparten el look moderno). Oculto SOLO en pipes-request (requestFlow && !onlyStation):
                 esa vista ya no muestra el Cronograma (redundante con la tabla "Solicitudes" de arriba).
                 En la vista de solicitud de la ESTACIÓN el Cronograma se MOVIÓ a su propia
                 página del menú (task 2026-07-10, /gasprecio/cronograma-pipas → cronoOnly):
                 acá solo se pinta en view=pipes (!requestFlow) o en esa página (cronoOnly). -->
      <div
        class="pipes-crono pipes-req__section"
        *ngIf="!requestFlow || (onlyStation && cronoOnly)"
      >
        <!-- Banda título + filtros del Cronograma de la GUÍA (requestFlow && onlyStation,
                 task 2026-07-10 "traer los filtros a esta tabla" — restaura la banda que se
                 perdió en el merge del rediseño): Semana (control compartido con Solicitudes
                 vía SharedService, sincronizadas a propósito — la semana gobierna el fetch de
                 ambas tablas) y Producto con filtro PROPIO (cronoProductFilter: cada card
                 filtra lo suyo; sin Estatus porque este cronograma solo lista confirmadas).
                 ⚠️ SIN gate por reqst (mismo motivo que las demás bandas, ver comentario
                 de abajo): recrear el app-select-week dispara el loop de requests. -->
        <div class="pipes-req__orders-head" *ngIf="requestFlow">
          <h2 class="pipes-req__section-title">Cronograma</h2>
          <div class="pipes-req__orders-filters">
            <div class="pipes-req__field">
              <app-select-week currentWeekLabel="Semana actual"></app-select-week>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterProducts"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los productos"
                [(ngModel)]="cronoProductFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
          </div>
        </div>
        <!-- Header moderno del Cronograma del Tablero (view=pipes, !requestFlow), patrón
                 .pipes-req__orders-head de "Solicitudes" (ver arriba). app-last-update se
                 reubica acá (antes vivía en el header legacy que se eliminó). -->
        <!-- El header (con los selects Grupo/Zona/Semana) NO se gatea por reqst: si se
                 destruyera/recreara en cada getData (reqst 0→1), al recrearse los selects
                 re-emitirían al servicio compartido (sharedZone/sharedWeek/sharedGroup) y
                 dispararían otro getData → loop infinito. Mismo criterio que "Solicitudes":
                 el header persiste y SOLO la tabla de abajo se gatea por reqst. -->
        <div class="pipes-req__orders-head" *ngIf="!requestFlow">
          <h2 class="pipes-req__section-title">Cronograma</h2>
          <!-- Filtros SIN label, solo placeholder/opción descriptiva (task
                       2026-07-10 "eliminar los títulos" — mismo criterio que la banda
                       de Solicitudes del flujo). -->
          <div class="pipes-req__orders-filters">
            <div class="pipes-req__field" *ngIf="rol === 'Dios'">
              <app-select-group></app-select-group>
            </div>
            <div class="pipes-req__field">
              <app-select-market></app-select-market>
            </div>
            <div class="pipes-req__field">
              <!-- Mismo dropdown buscable de estaciones que "Solicitudes" (sin "X" de
                           limpiar: stationFilterOptions ya trae "Todas las estaciones" como
                           primera opción para volver a "sin filtro"). -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="stationFilterOptions"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todas las estaciones"
                [(ngModel)]="stationFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
                <ng-template ngx-select-option-not-found let-input
                  >"{{ input }}" no encontrada</ng-template
                >
              </ngx-select>
            </div>
            <div class="pipes-req__field">
              <app-select-week currentWeekLabel="Semana actual"></app-select-week>
            </div>
            <div class="pipes-req__field">
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="orderFilterProducts"
                optionValueField="value"
                optionTextField="label"
                placeholder="Todos los productos"
                [(ngModel)]="productFilter"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="applyFilters()"
              >
              </ngx-select>
            </div>
            <!-- Sin filtro de Estatus (task 2026-07-10): sus opciones eran estatus de
                 fuel-orders (strings) pero las COMPRAS de esta tabla traen un ObjectId
                 del catálogo purchase_status — seleccionar cualquiera vaciaba la tabla.
                 Ya se había quitado el 2026-07-09; el rediseño lo re-agregó por error. -->
          </div>
        </div>
        <!-- Sin scroll virtual (scrollbarV=false) ni altura fija: la tabla se dimensiona
                 al contenido de la página actual (máx. cronoPageSize filas: 5 en el flujo,
                 15 en el Tablero donde la tabla es el único contenido), igual que la
                 tabla "Solicitudes". Así NO queda espacio muerto entre la última fila y el
                 paginador (el scroll virtual con altura fija reservaba header + 5 filas + track
                 del scrollbar aunque la página trajera menos). El look moderno (.orders-cronograma)
                 y la paginación aplican en las 3 vistas por igual. -->
        <!-- Sin paginación (pedido 2026-07-13): todas las entregas bajo el scroll
             interno del wrapper (max-height = header + cronoPageSize filas, según
             la vista), pintadas por lotes (ver onCronoScroll). -->
        <div
          class="crono-scroll"
          [style.max-height.px]="50 + cronoPageSize * 32"
          (scroll)="onCronoScroll($event)"
        >
        <ngx-datatable
          *ngIf="reqst === 1"
          class="bootstrap selection-cell orders-cronograma"
          [class.crono-empty-lg]="cronoPageSize === cronoBoardPageSize"
          [style.--crono-empty-height]="cronoEmptyHeight"
          [columnMode]="'force'"
          [headerHeight]="50"
          [rowHeight]="getRowHeight"
          [rows]="temp"
          [rowClass]="getRowClass"
          [scrollbarV]="false"
          [scrollbarH]="true"
          [selected]="selected"
          [selectionType]="SelectionType.multiClick"
          [messages]="{ emptyMessage: emptyCronogramaMessage }"
        >
          <!-- Estación: SOLO en Tablero (task 2026-07-09 "en Inventario sí se debe
               ver de quién es cada pipa"); en la vista de estación es implícita. -->
          <ngx-datatable-column
            *ngIf="!onlyStation"
            prop="station_name"
            [width]="100"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Estación</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.station_name || "—" }}
            </ng-template>
          </ngx-datatable-column>

          <!-- Zona: SOLO en el cronograma del Tablero (fix 2026-07-10, acompaña al
               filtro de Zona del header); en la vista de estación la zona es
               implícita. frozenLeft para mantener contiguo el bloque congelado
               (Estación/Zona/Producto/Material). El row.zone ya llega capitalizado
               desde el mapeo de getData. -->
          <ngx-datatable-column
            *ngIf="!requestFlow"
            prop="zone"
            [width]="80"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Zona</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.zone || "—" }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="product"
            [width]="70"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Producto</span>
            </ng-template>
            <!-- Badge soft-tint (task 2026-07-09, espejo del badge de Estatus)
                 conservando la identidad de color de producto del portal:
                 regular verde, premium rojo, diésel oscuro; total/otros en el
                 gris neutro base del pill. -->
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="status-label text-capitalize"
                [ngClass]="{
                  'product-regular': row.product === 'regular',
                  'product-premium': row.product === 'premium',
                  'product-diesel': row.product === 'diesel',
                }"
              >
                {{ row.product }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Material capturado en la solicitud -->
          <ngx-datatable-column
            prop="material"
            [width]="130"
            [frozenLeft]="true"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Material</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="material-cell" [title]="row.material || ''">{{
                row.material || "—"
              }}</span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Comerc, Turno y Fecha y Hora Actualización se ELIMINARON del cronograma
               (task 2026-07-09 "eliminar campos innecesarios": aplica al flujo MOBICO
               Y al cronograma legacy de Inventario, confirmado por el equipo). -->

          <ngx-datatable-column
            prop="liters_requested"
            [width]="66"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Litros<br />Solicitados</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.liters_requested | number: "1.0-0" }}
            </ng-template>
          </ngx-datatable-column>

          <!-- Estatus: SOLO en el cronograma de compras del Tablero, donde sí varía
               (Entregada/Cancelada/… del catálogo purchase_status en compras manuales).
               En el flujo (source='orders' + requestFlow) se OCULTA: cronogramaBase
               solo deja pasar confirmadas, la columna siempre decía "Confirmada"
               (task 2026-07-10 "eliminar la columna de estatus del cronograma"). -->
          <ngx-datatable-column
            *ngIf="!(source === 'orders' && requestFlow)"
            prop="statusName"
            [width]="52"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Estatus</span>
            </ng-template>
            <!-- Badge con colores descriptivos (task 2026-07-09), mismo pill que la
                 columna "Respuesta MOBICO" de Solicitudes: verde confirmada, azul
                 entregada, rojo rechazada; lo demás (Cancelada/Pendiente/...) queda
                 en el gris neutro base — igual que Cancelada en Solicitudes. -->
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="status-label"
                [ngClass]="{
                  'status-confirmed': row.statusName === 'Confirmada',
                  'status-delivered': row.statusName === 'Entregada',
                  'status-rejected': row.statusName === 'Rechazada'
                }"
              >
                {{ row.statusName }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="date"
            [width]="56"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Fecha de<br />Solicitud</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- En solicitudes la fecha es un timestamp real → hora de México (-0600) -->
              {{
                row.date
                  | date
                    : "dd/MM/yy"
                    : (source === "orders" ? "-0600" : "+0000")
                    : "es"
              }}
            </ng-template>
          </ngx-datatable-column>

          <!-- prop = el campo que la celda PINTA (antes ambas columnas de fecha
               ordenaban por status_date, que no es lo que muestran). -->
          <ngx-datatable-column
            prop="expected_delivery_date"
            [width]="56"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Fecha<br />Requerida</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row.expected_delivery_date | date: "dd/MM/yy" : "+0000" : "es"
              }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="delivery_date"
            [width]="56"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Fecha de<br />Entrega</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row.delivery_date
                  ? (row.delivery_date | date: "dd/MM/yy" : "+0000" : "es")
                  : "—"
              }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="liters"
            [width]="66"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span>Litros<br />Entregados</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.liters != null ? (row.liters | number: "1.0-0") : "—" }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            prop="total"
            [width]="60"
            [headerClass]="'top-side'"
          >
            <ng-template ngx-datatable-header-template>
              <span title="No incluye IVA, ni descuento"
                >Costo<br />Total
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  style="color: #9b9b9b"
                ></i
              ></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row.total != null ? "$ " + (row.total | number: "1.0-0") : "—"
              }}
            </ng-template>
          </ngx-datatable-column>

          <!-- En modo solicitudes Costo Litro cierra el borde derecho SALVO para el
               admin MOBICO, que tiene la columna Acciones después (la col. Fecha y Hora
               Actualización que lo cerraba antes se eliminó, task 2026-07-09). -->
          <ngx-datatable-column
            prop="supply_price"
            [width]="40"
            [cellClass]="
              source === 'orders' && !isMobicoAdmin ? 'right-side' : ''
            "
            [headerClass]="
              source === 'orders' && !isMobicoAdmin
                ? 'top-side right-side'
                : 'top-side'
            "
          >
            <ng-template ngx-datatable-header-template>
              <span>Costo<br />Litro</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row.supply_price != null
                  ? "$ " + (row.supply_price | number: "1.2-2")
                  : "—"
              }}
            </ng-template>
          </ngx-datatable-column>

          <!-- Acciones del cronograma del flujo, SOLO para el admin MOBICO: edición
                     DIRECTA de la entrega (fecha real y costos), sin flujo de aprobación y
                     sin opción de eliminar. -->
          <ngx-datatable-column
            *ngIf="source === 'orders' && isMobicoAdmin"
            name="Acciones"
            [width]="80"
            [minWidth]="76"
            [sortable]="false"
            [cellClass]="'right-side'"
            [headerClass]="'top-side right-side'"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <button
                type="button"
                class="row-action-btn green"
                title="Editar entrega y costos"
                (click)="openDeliveryEdit(row)"
              >
                Editar
              </button>
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>
        </div>
      </div>
      <div class="row" style="margin: 10px" *ngIf="reqst === 0">
        <app-table-loader style="width: 100%"></app-table-loader>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="modal-add"
  tabindex="-1"
  role="dialog"
  aria-labelledby="tableColumns"
  aria-hidden="true"
>
  <div class="modal-dialog medium-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center" id="tableColumns">
          Ingresa los datos de la pipa
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body medium">
        <form [formGroup]="newForm">
          <div class="content">
            <label class="subtitle" for="station_name">
              <span>Estación</span>
            </label>
            <div *ngIf="showStations">
              <epy-select
                [options]="stations"
                placeholder="Seleccionar Estación"
                [value]="stationSelected"
                filter="true"
                filter-placeholder="Buscar Estación"
                not-found-copy="Sin resultados"
                (selectChange)="changeStation($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="product">
              <span>Producto</span>
            </label>
            <div>
              <epy-select
                [options]="products"
                placeholder="Seleccionar Producto"
                [value]="product"
                (selectChange)="changeProduct($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="marketSelected">
              <span>Comercializadora</span>
            </label>
            <div *ngIf="showMarketers">
              <epy-select
                [options]="marketers"
                placeholder="Seleccionar Comercializadora"
                [value]="marketSelected"
                filter="true"
                filter-placeholder="Buscar Comercializadora"
                not-found-copy="Sin resultados"
                (selectChange)="changeMarketer($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="total" *ngIf="marketerName === 'OTRA'">
              <span>Nombre de la Comercializadora</span>
            </label>
            <br *ngIf="marketerName === 'OTRA'" />
            <input
              maxLength="16"
              class="all"
              type="text"
              formControlName="marketOther"
              *ngIf="marketerName === 'OTRA'"
            />
            <br *ngIf="marketerName === 'OTRA'" />

            <label class="subtitle" for="shiftSelected">
              <span>Turno</span>
            </label>
            <div *ngIf="showWorkShifts">
              <epy-select
                [options]="workshifts"
                placeholder="Seleccionar Turno"
                [value]="shiftSelected"
                (selectChange)="changeShift($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="litersRequested">
              <span>Litros Solicitados</span>
            </label>
            <br />
            <input
              maxLength="6"
              class="all"
              type="text"
              formControlName="litersRequested"
              (keypress)="numberOnly($event)"
            />
            <br />

            <label class="subtitle" for="statusSelected">
              <span>Estatus</span>
            </label>
            <div *ngIf="showStatus">
              <epy-select
                [options]="status"
                placeholder="Seleccionar Estatus"
                [value]="statusSelected"
                (selectChange)="changeStatus($event)"
              >
              </epy-select>
            </div>

            <label class="subtitle" for="date">
              <span>Fecha de Solicitud</span>
            </label>
            <br />
            <input
              class="all"
              type="date"
              formControlName="date"
              min="2020-12-01"
              [max]="maxDate"
            />
            <br />

            <label class="subtitle" for="date">
              <span>Fecha Estimada de Entrega</span>
            </label>
            <br />
            <input
              class="all"
              type="date"
              formControlName="expectedDeliverateDate"
              min="2020-12-01"
              [max]="maxDate"
            />
            <br />

            <label
              class="subtitle"
              for="date"
              *ngIf="statusName === 'Cancelada'"
            >
              <span>Fecha de Cancelación</span>
            </label>
            <br *ngIf="statusName === 'Cancelada'" />
            <input
              class="all"
              type="date"
              formControlName="cancellationDate"
              min="2020-12-01"
              [max]="maxDate"
              *ngIf="statusName === 'Cancelada'"
            />
            <br *ngIf="statusName === 'Cancelada'" />

            <label
              class="subtitle"
              for="date"
              *ngIf="statusName === 'Entregada'"
            >
              <span>Fecha de Entrega</span>
            </label>
            <br *ngIf="statusName === 'Entregada'" />
            <input
              class="all"
              type="date"
              formControlName="deliverateDate"
              min="2020-12-01"
              [max]="maxDate"
              *ngIf="statusName === 'Entregada'"
            />
            <br *ngIf="statusName === 'Entregada'" />

            <label
              class="subtitle"
              for="litersRequested"
              *ngIf="statusName === 'Entregada'"
            >
              <span>Litros Entregados</span>
            </label>
            <br *ngIf="statusName === 'Entregada'" />
            <input
              maxLength="6"
              class="all"
              type="text"
              formControlName="liters"
              *ngIf="statusName === 'Entregada'"
              (keypress)="numberOnly($event)"
            />
            <br *ngIf="statusName === 'Entregada'" />

            <label class="subtitle" for="total">
              <span>Costo Total</span>
            </label>
            <br />
            <input
              maxLength="10"
              class="all"
              type="text"
              formControlName="total"
              (keypress)="numberOnly($event)"
            />
            <br />

            <label class="subtitle" for="statusDate">
              <span>Fecha de Actualización</span>
            </label>
            <br />
            <input
              class="all"
              type="date"
              disabled
              min="2020-12-01"
              [max]="max"
              [value]="max"
            />
          </div>
        </form>
      </div>
      <div class="footer-modal">
        <button
          type="button"
          class="add"
          data-dismiss="modal"
          (click)="addPipe()"
          *ngIf="mode === 'add'"
        >
          Agregar
        </button>
        <button
          type="button"
          class="add"
          data-dismiss="modal"
          (click)="addPipe()"
          *ngIf="mode === 'edit'"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal: nueva solicitud de pipa (fuel-orders, varias pipas por solicitud) -->
<div
  class="modal fade op-modal"
  [class.show]="showOrderForm"
  [class.op-wide]="!onlyStation"
  [style.display]="showOrderForm ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="opTitle"
  [attr.aria-hidden]="!showOrderForm"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="opTitle">
          {{
            orderEditMode
              ? "Editar solicitud de pipa"
              : "Nueva solicitud de pipa"
          }}
        </h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="cancelOrderForm()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Una pipa por bloque; cada bloque es una fila estilo Excel. -->
        <div class="op-block" *ngFor="let f of orderForms; let i = index">
          <div class="op-head" *ngIf="!orderEditMode">
            <span class="op-title">Pipa {{ i + 1 }}</span>
            <!-- Patrón estándar de eliminar del portal (mismo ícono .icon.delete del
                             cronograma de esta pantalla). Siempre visible: deshabilitado con una sola pipa. -->
            <i
              class="fa fa-trash-o icon delete"
              aria-hidden="true"
              [class.disabled]="orderForms.length < 2"
              (click)="orderForms.length > 1 && removeOrderRow(i)"
              [title]="
                orderForms.length > 1
                  ? 'Eliminar pipa'
                  : 'La solicitud necesita al menos una pipa'
              "
            ></i>
          </div>
          <div class="op-row">
            <div class="op-field">
              <label>PO#</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="f.po"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Ej. PET8EX01"
              />
            </div>
            <div class="op-field">
              <label>Fecha requerida</label>
              <input
                type="date"
                class="form-control"
                [class.is-placeholder]="!f.loadDate"
                [class.is-invalid]="rowDateTooEarly(f)"
                [min]="minRequestDate"
                [title]="rowDateTooEarly(f) ? 'La fecha requerida no puede ser anterior a hoy' : ''"
                [(ngModel)]="f.loadDate"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              />
            </div>
            <!-- Estación: solo en modo grupo (en estación es implícita). Va después de
                             Fecha requerida, como el formato MOBICO (PO · FECHA REQUERIDA · ESTACIÓN).
                             ngx-select (mismo componente buscable que los selectores de Zona): se escribe el nombre y filtra. -->
            <div class="op-field op-field-station" *ngIf="!onlyStation">
              <label>Estación</label>
              <!-- appendTo body: el desplegable se renderiza fuera del cuerpo con scroll
                                 para que el scroll interno del modal no lo recorte. -->
              <ngx-select
                class="op-ngx-select"
                [allowClear]="false"
                [items]="stations"
                optionValueField="value"
                optionTextField="label"
                placeholder="Selecciona…"
                appendTo="body"
                [dropDownMenuOtherClasses]="'op-appended-dropdown'"
                [(ngModel)]="f.station"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              >
                <ng-template ngx-select-option-not-found let-input>
                  "{{ input }}" no encontrada
                </ng-template>
              </ngx-select>
            </div>
            <div class="op-field op-field-capacity">
              <label>Capacidad</label>
              <!-- Texto con separador de miles (el modelo sigue numérico vía parseThousands). -->
              <input
                type="text"
                inputmode="numeric"
                class="form-control"
                (keypress)="numberOnly($event)"
                [class.over-space]="rowOverSpace(f)"
                [ngModel]="formatThousands(f.capacity)"
                (ngModelChange)="f.capacity = parseThousands($event)"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Ej. 30,000"
              />
              <!-- Candado de inventario: espacio del tanque proyectado a la fecha requerida.
                                 Pills de una línea apilados dentro de la columna (min-width en
                                 .op-field-capacity garantiza que quepan sin envolver). -->
              <small class="space-hint muted" *ngIf="f.spaceLoading">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                Consultando espacio…
              </small>
              <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin
                   ampliar más"): click abre "¿Por qué no hay espacio?". -->
              <small
                class="space-hint"
                [class.over]="rowOverSpace(f)"
                *ngIf="!f.spaceLoading && f.availableSpace != null"
                (click)="rowOverSpace(f) && openSpaceInfo(f)"
                [title]="
                  rowOverSpace(f)
                    ? 'Ver por qué no hay espacio'
                    : f.spaceBasis === 'theoretical'
                      ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                      : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
                "
              >
                <i
                  class="fa"
                  [ngClass]="
                    rowOverSpace(f) ? 'fa-exclamation-triangle' : 'fa-tint'
                  "
                  aria-hidden="true"
                ></i>
                <span>
                  <ng-container *ngIf="!rowOverSpace(f)"
                    >Espacio disp.
                    {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                  >
                  <ng-container *ngIf="rowOverSpace(f) && rowEffectiveSpace(f)"
                    >Excede máx.
                    {{ rowEffectiveSpace(f) | number: "1.0-0" }} lts.</ng-container
                  >
                  <ng-container *ngIf="rowOverSpace(f) && !rowEffectiveSpace(f)"
                    >Sin espacio disponible</ng-container
                  >
                  <i
                    class="fa fa-question-circle space-hint__q"
                    *ngIf="rowOverSpace(f)"
                    aria-hidden="true"
                  ></i>
                </span>
              </small>
              <small
                class="space-hint muted"
                *ngIf="
                  !f.spaceLoading && f.spaceChecked && f.availableSpace == null
                "
                title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
              >
                <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos
                de inventario
              </small>
            </div>
            <div class="op-field">
              <label>Tipo</label>
              <select
                class="form-control"
                [class.is-placeholder]="!f.product"
                [(ngModel)]="f.product"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateRowSpace(f)"
              >
                <option value="" disabled selected>Selecciona…</option>
                <option *ngFor="let p of orderProductOptions" [value]="p.value">
                  {{ p.label }}
                </option>
              </select>
            </div>
            <div class="op-field op-field-grow">
              <label>Material</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="f.material"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Ej. MOBIL R87 OCT GASOLINE MEXICO ROC"
              />
            </div>
          </div>
        </div>

        <!-- Mismo patrón "Agregar +" del portal (reporte de compras, new-report-ope):
                     texto en negritas + fa-plus verde text-success. -->
        <button
          type="button"
          class="op-add-more"
          *ngIf="!orderEditMode"
          (click)="addOrderRow()"
        >
          Añadir pipa <i class="fa fa-plus text-success" aria-hidden="true"></i>
        </button>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link op-cancel" (click)="cancelOrderForm()">
          Cancelar
        </button>
        <button
          class="op-btn"
          (click)="submitOrderForm()"
          [disabled]="!orderFormValid || savingOrder"
        >
          {{
            savingOrder ? "Guardando…" : orderEditMode ? "Guardar" : "Enviar"
          }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="showOrderForm"
  (click)="cancelOrderForm()"
></div>

<!-- Modal: realizar cambio sobre un pedido (solicitud de cambio a MOBICO; el pedido
     original se modifica hasta que MOBICO la aprueba en su panel) -->
<div
  class="modal fade op-modal op-wide op-confirm"
  [class.show]="showChangeForm"
  [style.display]="showChangeForm ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="changeTitle"
  [attr.aria-hidden]="!showChangeForm"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- Mismo header de "Aprobar solicitud" (op-confirm): ícono en círculo + título -->
        <div class="confirm-icon" aria-hidden="true">
          <img src="/assets/icons/alert-confirm.svg" alt="" width="26" height="26" />
        </div>
        <h5 class="modal-title" id="changeTitle">Realizar cambio</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="cancelChangeForm()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Tipo de cambio arriba, separado del formato -->
        <div class="op-row op-change-type">
          <div class="op-field">
            <label>Tipo de cambio</label>
            <select
              class="form-control"
              [(ngModel)]="changeForm.type"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="refreshChangeSpace()"
            >
              <option *ngFor="let t of changeTypeOptions" [value]="t.value">
                {{ t.label }}
              </option>
            </select>
          </div>
        </div>

        <!-- Formato MOBICO en UNA sola línea: PO · Fecha requerida · Estación ·
                         Capacidad · Producto (solo lectura en gris) + el campo nuevo del tipo. -->
        <div class="op-row">
          <div class="op-field">
            <label>PO#</label>
            <input
              type="text"
              class="form-control"
              [value]="changeRow?.po_number || '—'"
              disabled
            />
          </div>
          <div class="op-field">
            <label>Fecha requerida</label>
            <input
              type="text"
              class="form-control"
              [value]="
                changeRow?.order_delivery_date
                  ? (changeRow.order_delivery_date
                    | date: 'dd/MM/yy' : '+0000' : 'es')
                  : '—'
              "
              disabled
            />
          </div>
          <!-- Reparto 2026-07-13: Estación y el campo nuevo llevan 1.5× (los que
               más texto cargan); Producto cede su doble ancho (los materiales
               largos truncan con ellipsis, el valor completo vive en la tabla). -->
          <div class="op-field op-field-wide">
            <label>Estación</label>
            <input
              type="text"
              class="form-control"
              [value]="changeRow?.station_name || '—'"
              disabled
            />
          </div>
          <div class="op-field">
            <label>Capacidad</label>
            <input
              type="text"
              class="form-control"
              [value]="
                changeRow?.truck_capacity
                  ? (changeRow.truck_capacity | number: '1.0-0')
                  : '—'
              "
              disabled
            />
          </div>
          <div class="op-field">
            <label>Producto</label>
            <input
              type="text"
              class="form-control"
              [value]="changeRow?.material || '—'"
              [title]="changeRow?.material || ''"
              disabled
            />
          </div>
          <div class="op-field op-field-wide" *ngIf="changeForm.type === 'date'">
            <label>Nueva fecha</label>
            <input
              type="text"
              class="form-control cal-input"
              readonly
              placeholder="Selecciona la fecha"
              [value]="
                changeForm.newDate
                  ? (changeForm.newDate | date: 'dd/MM/yy' : '+0000' : 'es')
                  : ''
              "
              (click)="toggleChangeCalendar($event)"
            />
          </div>
          <div class="op-field op-field-wide" *ngIf="changeForm.type === 'capacity'">
            <label>Nueva capacidad</label>
            <!-- Texto con separador de miles (el modelo sigue numérico vía parseThousands). -->
            <input
              type="text"
              inputmode="numeric"
              class="form-control"
              (keypress)="numberOnly($event)"
              [class.over-space]="changeOverSpace"
              [ngModel]="formatThousands(changeForm.newCapacity)"
              (ngModelChange)="changeForm.newCapacity = parseThousands($event)"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. 30,000"
            />
          </div>
          <div class="op-field op-field-wide" *ngIf="changeForm.type === 'product'">
            <label>Nuevo producto</label>
            <select
              class="form-control"
              [class.is-placeholder]="!changeForm.newProduct"
              [(ngModel)]="changeForm.newProduct"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="refreshChangeSpace()"
            >
              <option value="" disabled selected>Selecciona…</option>
              <option *ngFor="let p of orderProductOptions" [value]="p.value">
                {{ p.label }}
              </option>
            </select>
          </div>
          <div
            class="op-field op-field-grow"
            *ngIf="changeForm.type === 'product'"
          >
            <label>Nuevo material</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="changeForm.newMaterial"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Ej. MOBIL R87 OCT GASOLINE MEXICO ROC"
            />
          </div>
        </div>
        <!-- Calendario del cambio de fecha ANCLADO bajo el campo "Nueva fecha"
                         (task 2026-07-10, iteración: "que aparezca abajo de Nueva fecha, como el
                         picker nativo de Fecha requerida"): capa fija transparente que atrapa el
                         click-fuera + panel posicionado junto al input (calPanelPos, calculado al
                         abrir). Conserva el estilo del picker (fecha actual gris no seleccionable,
                         nueva en verde); elegir un día lo cierra (onCalSelect). Capa fija: no lo
                         recorta el overflow:hidden del .modal-content ni empuja el layout. -->
        <div
          class="op-cal-overlay"
          *ngIf="changeForm.type === 'date' && showChangeCalendar"
          (click)="showChangeCalendar = false"
        >
        <div
          class="op-mini-cal op-mini-cal--modal"
          [ngStyle]="calPanelPos"
          (click)="$event.stopPropagation()"
        >
          <!-- footerTemplate: la leyenda de colores vive DENTRO de la tarjeta del
                           propio datepicker (pedido 2026-07-10: sin card contenedora extra,
                           pero el significado de cada color sí es importante). -->
          <ngb-datepicker
            [startDate]="calStartDate"
            [minDate]="calMinDate"
            navigation="arrows"
            [markDisabled]="calMarkDisabled"
            [dayTemplate]="calDay"
            [footerTemplate]="calFooter"
            (dateSelect)="onCalSelect($event)"
          ></ngb-datepicker>
          <ng-template #calFooter>
            <div class="cal-legend">
              <span class="cal-dot current"></span> Fecha actual
              <span class="cal-dot selected"></span> Nueva fecha
            </div>
          </ng-template>
          <ng-template
            #calDay
            let-date
            let-currentMonth="currentMonth"
            let-disabled="disabled"
          >
            <span
              class="cal-day"
              [class.cal-outside]="date.month !== currentMonth"
              [class.cal-disabled]="disabled"
              [class.cal-current]="isCalCurrent(date)"
              [class.cal-selected]="isCalSelected(date)"
              >{{ date.day }}</span
            >
          </ng-template>
          <!-- La leyenda "Fecha actual / Nueva fecha" se retiró junto con la card
                           contenedora (feedback 2026-07-10 "solo deja el picker"): flotaría
                           suelta sobre el fondo sin la tarjeta que la sostenía. -->
        </div>
        </div>
        <!-- Candado de inventario: espacio del tanque con los valores del cambio -->
        <small class="space-hint muted" *ngIf="changeSpaceLoading">
          <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
          Consultando espacio…
        </small>
        <!-- El pill rojo ES el botón del desglose (2026-07-13 v2 "sin ampliar
             más"): click abre "¿Por qué no hay espacio?". -->
        <small
          class="space-hint"
          [class.over]="changeOverSpace"
          *ngIf="!changeSpaceLoading && changeSpace != null"
          (click)="changeOverSpace && openChangeSpaceInfo()"
          [title]="
            changeOverSpace
              ? 'Ver por qué no hay espacio'
              : changeSpaceBasis === 'theoretical'
                ? 'Espacio a la fecha de entrega: capacidad del tanque menos inventario TEÓRICO del día (el mismo del Cronograma) y arrastre'
                : 'Espacio a la fecha de entrega: capacidad del tanque menos la lectura real del volumétrico y arrastre'
          "
        >
          <i
            class="fa"
            [ngClass]="changeOverSpace ? 'fa-exclamation-triangle' : 'fa-tint'"
            aria-hidden="true"
          ></i>
          <span>
            <ng-container *ngIf="!changeOverSpace"
              >Espacio disp.
              {{ changeSpace | number: "1.0-0" }} lts.</ng-container
            >
            <ng-container *ngIf="changeOverSpace && changeSpace"
              >Excede máx.
              {{ changeSpace | number: "1.0-0" }} lts.</ng-container
            >
            <ng-container *ngIf="changeOverSpace && !changeSpace"
              >Sin espacio disponible</ng-container
            >
            <i
              class="fa fa-question-circle space-hint__q"
              *ngIf="changeOverSpace"
              aria-hidden="true"
            ></i>
          </span>
        </small>
        <small
          class="space-hint muted"
          *ngIf="
            !changeSpaceLoading && changeSpaceChecked && changeSpace == null
          "
          title="La estación no tiene capacidad de tanque o lectura de inventario para este producto"
        >
          <i class="fa fa-info-circle" aria-hidden="true"></i> Sin datos de
          inventario
        </small>
        <!-- REGLA DESACTIVADA (2026-07-06): avisos de la escalera de cambios 48/24 hrs.
                         Descomentar junto con changeDeadlineState (TS) y .space-hint.waitlist (SCSS):
                    <small class="space-hint waitlist" *ngIf="changeDeadlineState === 'waitlist'"
                        title="Los cambios se atienden si se reciben antes de las 10:00 am de dos días antes de la entrega">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        Solicitud con menos de 48 hrs de anticipación: quedará en espera de disponibilidad.
                    </small>
                    <small class="space-hint over" *ngIf="changeDeadlineState === 'late'">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        Fuera de tiempo: los cambios se reciben a más tardar a las 10:00 am del día previo a la entrega.
                    </small>
                    -->
      </div>
      <div class="modal-footer">
        <button class="confirm-btn gray" (click)="cancelChangeForm()">
          Cancelar
        </button>
        <button
          class="confirm-btn green"
          (click)="submitChangeForm()"
          [disabled]="!changeFormValid || savingChange"
        >
          {{ savingChange ? "Enviando…" : "Enviar solicitud" }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="showChangeForm"
  (click)="cancelChangeForm()"
></div>

<!-- Modal de edición DIRECTA de entrega (solo admin MOBICO, desde el cronograma):
     misma anatomía que el modal de cambio del solicitante — datos del pedido en
     inputs deshabilitados + sección editable — pero aquí los cambios aplican de
     inmediato (PATCH), sin flujo de aprobación. -->
<div
  class="modal fade op-modal"
  [class.show]="!!deliveryEditRow"
  [style.display]="deliveryEditRow ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deliveryEditTitle"
  [attr.aria-hidden]="!deliveryEditRow"
>
  <div class="modal-dialog op-delivery-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deliveryEditTitle">Editar entrega</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="cancelDeliveryEdit()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="deliveryEditRow">
        <div class="op-block">
          <div class="op-head">
            <span class="op-title">Datos del pedido</span>
          </div>
          <div class="op-row">
            <div class="op-field">
              <label>PO</label>
              <input
                type="text"
                class="form-control"
                [value]="deliveryEditRow.po_number || '—'"
                disabled
              />
            </div>
            <div class="op-field op-field-grow">
              <label>Estación</label>
              <input
                type="text"
                class="form-control"
                [value]="deliveryEditRow.station_name || ''"
                disabled
              />
            </div>
            <div class="op-field op-field-grow">
              <label>Producto</label>
              <input
                type="text"
                class="form-control"
                [value]="
                  deliveryEditRow.material || deliveryEditRow.product || ''
                "
                disabled
              />
            </div>
            <div class="op-field">
              <label>Litros</label>
              <input
                type="text"
                class="form-control"
                [value]="
                  deliveryEditRow.liters_requested
                    ? (deliveryEditRow.liters_requested | number: '1.0-0')
                    : '—'
                "
                disabled
              />
            </div>
          </div>
        </div>
        <div class="op-block">
          <div class="op-head">
            <span class="op-title">Datos de la entrega</span>
          </div>
          <div class="op-row">
            <div class="op-field">
              <label for="deliveryEditDate">Fecha de entrega</label>
              <input
                id="deliveryEditDate"
                type="date"
                class="form-control"
                [(ngModel)]="deliveryEditDate"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
            <div class="op-field">
              <label for="deliveryEditTotal">Costo total (opcional)</label>
              <input
                id="deliveryEditTotal"
                type="number"
                class="form-control"
                placeholder="Ej. 450000"
                [(ngModel)]="deliveryEditTotal"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
            <div class="op-field">
              <label for="deliveryEditPrice">Costo por litro (opcional)</label>
              <input
                id="deliveryEditPrice"
                type="number"
                class="form-control"
                placeholder="Ej. 22.5"
                [(ngModel)]="deliveryEditPrice"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <p class="op-direct-note">
            Los cambios aplican de inmediato y se reflejan en todos los
            cronogramas.
          </p>
        </div>
        <p class="confirm-error" *ngIf="deliveryEditError">
          {{ deliveryEditError }}
        </p>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-link op-cancel"
          (click)="cancelDeliveryEdit()"
          [disabled]="savingDeliveryEdit"
        >
          Cancelar
        </button>
        <button
          class="op-btn"
          (click)="submitDeliveryEdit()"
          [disabled]="!deliveryEditValid || savingDeliveryEdit"
        >
          {{ savingDeliveryEdit ? "Guardando…" : "Guardar cambios" }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="deliveryEditRow"
  (click)="cancelDeliveryEdit()"
></div>

<!-- Modal de confirmación de cancelación: anatomía del custom-alert REAL del portal
     (header neutro, ícono auto-coloreado, título oscuro), texto simple con el PO,
     error inline. Botones como en todo el portal: gris cerrar, verde confirmar.
     Las respuestas de MOBICO se avisan con toast (showToast). -->
<div
  class="modal fade op-modal op-confirm"
  [class.show]="!!cancelTarget"
  [style.display]="cancelTarget ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="cancelTitle"
  [attr.aria-hidden]="!cancelTarget"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- Ícono en círculo translúcido, como los custom-alert del portal. -->
        <div class="confirm-icon" aria-hidden="true">
          <img
            src="/assets/icons/alert-confirm.svg"
            alt=""
            width="26"
            height="26"
          />
        </div>
        <h5 class="modal-title" id="cancelTitle">Cancelar solicitud</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="closeCancelConfirm()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="cancelTarget">
        <!-- Sujeto protagonista (chip + PO + estación) y consecuencia en tenue -->
        <div class="confirm-subject">
          <span class="type-chip" [ngClass]="cancelTarget.change_kind">{{
            cancelTarget.type_label
          }}</span>
          <span
            >PO {{ cancelTarget.po_number || "—" }} ·
            {{ cancelTarget.station_name || "" }}</span
          >
        </div>
        <p class="confirm-note">
          Se enviará a MOBICO la solicitud de cancelación y aplicará cuando la
          apruebe.
        </p>
        <p class="confirm-error" *ngIf="cancelError">{{ cancelError }}</p>
      </div>
      <div class="modal-footer">
        <button
          class="confirm-btn gray"
          (click)="closeCancelConfirm()"
          [disabled]="cancellingOrder"
        >
          Cerrar
        </button>
        <button
          class="confirm-btn green"
          (click)="confirmCancelOrder()"
          [disabled]="cancellingOrder"
        >
          {{ cancellingOrder ? "Enviando…" : "Solicitar cancelación" }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="cancelTarget"
  (click)="closeCancelConfirm()"
></div>

<!-- Modal informativo: desglose de POR QUÉ no hay espacio para la pipa capturada
     (task 2026-07-13 "modal de información de por qué no me deja comprar").
     Misma anatomía op-confirm del flujo; solo lectura, un botón para cerrar.
     La cuenta espeja al candado: capacidad − inventario a la fecha de entrega
     (real o teórico del Cronograma) − arrastre − pipas de esta solicitud que
     llegan antes = espacio disponible vs. lo capturado. -->
<div
  class="modal fade op-modal op-confirm"
  [class.show]="!!spaceInfo"
  [style.display]="spaceInfo ? 'flex' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="spaceInfoTitle"
  [attr.aria-hidden]="!spaceInfo"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="confirm-icon" aria-hidden="true">
          <img
            src="/assets/icons/alert-confirm.svg"
            alt=""
            width="26"
            height="26"
          />
        </div>
        <h5 class="modal-title" id="spaceInfoTitle">¿Por qué no hay espacio?</h5>
        <button
          type="button"
          class="close"
          aria-label="Cerrar"
          (click)="closeSpaceInfo()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="spaceInfo">
        <div class="space-info">
          <div class="space-info__row">
            <span>Capacidad del tanque</span>
            <b>{{
              spaceInfo.tank != null
                ? (spaceInfo.tank | number: "1.0-0") + " lts."
                : "—"
            }}</b>
          </div>
          <div class="space-info__row">
            <span
              >− Inventario
              {{ spaceInfo.basis === "real" ? "real" : "teórico" }}
              {{
                spaceInfo.invDate
                  ? "al " + (spaceInfo.invDate | date: "dd/MM/yy" : "+0000" : "es")
                  : ""
              }}</span
            >
            <b>{{
              spaceInfo.inventory != null
                ? (spaceInfo.inventory | number: "1.0-0") + " lts."
                : "—"
            }}</b>
          </div>
          <div class="space-info__row" *ngIf="spaceInfo.carry">
            <span>− Arrastre del tanque</span>
            <b>{{ spaceInfo.carry | number: "1.0-0" }} lts.</b>
          </div>
          <div class="space-info__row" *ngIf="spaceInfo.batch">
            <span>− Pipas de esta solicitud que llegan antes</span>
            <b>{{ spaceInfo.batch | number: "1.0-0" }} lts.</b>
          </div>
          <div class="space-info__row space-info__total">
            <span>= Espacio disponible</span>
            <b>{{
              spaceInfo.available != null
                ? (spaceInfo.available | number: "1.0-0") + " lts."
                : "—"
            }}</b>
          </div>
          <div
            class="space-info__row space-info__requested"
            *ngIf="spaceInfo.requested != null"
          >
            <span>Litros capturados</span>
            <b>{{ spaceInfo.requested | number: "1.0-0" }} lts.</b>
          </div>
        </div>
        <p class="confirm-note">
          Ajusta los litros o la fecha requerida para que la pipa quepa.
        </p>
      </div>
      <div class="modal-footer">
        <button class="confirm-btn green" (click)="closeSpaceInfo()">
          Entendido
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal-backdrop fade show"
  *ngIf="spaceInfo"
  (click)="closeSpaceInfo()"
></div>
